// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Icon$OrcaPaymentPage from "../Icon.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function ShowMoreToggle(props) {
  var setIsCollapsed = props.setIsCollapsed;
  var isCollapsed = props.isCollapsed;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  return React.createElement("div", {
              className: "Label flex flex-row gap-1 items-end cursor-pointer mt-3 text-sm font-medium float-left w-fit",
              style: {
                color: match.themeObj.colorPrimary
              },
              onClick: (function (param) {
                  setIsCollapsed(function (prev) {
                        return !prev;
                      });
                })
            }, isCollapsed ? localeString.showMore : localeString.showLess, React.createElement("div", {
                  className: "m-1"
                }, isCollapsed ? React.createElement(Icon$OrcaPaymentPage.make, {
                        name: "arrow-down",
                        size: 10
                      }) : React.createElement(Icon$OrcaPaymentPage.make, {
                        name: "arrow-up",
                        size: 10
                      })));
}

var make = ShowMoreToggle;

export {
  make ,
}
/* react Not a pure module */
